import * as mutationTypes from '@/store/mutation-types.js'
import stringOperations from '@/mixins/string-operations'
import dateOperations from '@/mixins/date-operations'
import basicOperations from '@/mixins/basic-operations.js'
import icons from '@/mixins/icons.js'

export default {
  name: 'GebruikerUsername',

  mixins: [basicOperations, stringOperations, dateOperations, icons],

  data() {
    return {
        username:'',
        serverLocation: null,
        serverLocationOfSelectedConnection: ''
    }
  },

  computed: {
    

  },

  mounted: function() {

    // Deze component opent altijd in Schoolware => bestaat niet in app versie!
   
    // if (this.$store.state.api === '') {
    //   this.$store.dispatch('apiCheck', {
    //     dezeDit: this,
    //     succesCallback: this.vervolgMounted
    //   })
    // } else {
    //   this.vervolgMounted()
    // }
    this.$store.commit(mutationTypes.SET_MENUBAR_ITEMS, {
      left: 'back',
      title: 'Gebruikersnaam',
      right: []
    })
   
    if (this.$route.params.id !== undefined) {
      var connectionObject = this.$store.getters.getConnectionWithID(this.$route.params.id);
      this.serverLocationOfSelectedConnection = connectionObject.serverLocation
    }
   
  
  },

  methods: {

    wachtwoordVergeten() {
     
      if (this.username.length > 0) {
        if (this.API === null) {
          this.$store.dispatch('apiCheck', {
            dezeDit: this,
            succesCallback: this.wachtwoordVergetenVervolg
          })
        } else {
          this.wachtwoordVergetenVervolg()
        }
      } else {
        this.$store.commit(mutationTypes.SHOW_MESSAGE, ['Gelieve een geldige gebruikersnaam op te geven.', 'long'])
      }
    },
    wachtwoordVergetenVervolg() {
      this.$store.dispatch('resetPasswordRequest', {
        dezeDit: this
      })
    },

  }
}
